import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {cloneDeep} from 'lodash';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import GridEdit from './GridEdit';
import {openExamEdit, openExamDelete} from '../../../redux/actions/exams';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {langExams} from '@language/index';
import {withStyles} from '@material-ui/core';
import {styles} from '../../../styles/documents';
import Typography from '@material-ui/core/Typography';
import {findExamIndex, findExamTypeIndex} from '@helpers/find';
import {configExamTypes, configExamTypesTranslatedConf} from '../../../config/exams';
import IconButton from '@material-ui/core/IconButton';
import {Edit, Close} from '@material-ui/icons';
import GridDelete from './GridDelete';
import {withTranslation} from "react-i18next";

class GridContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleEditOpen = this.handleEditOpen.bind(this);
        this.handleDeleteOpen = this.handleDeleteOpen.bind(this);
    }
    handleEditOpen = (id = 0) => {
        const {openExamEdit, t} = this.props;
        openExamEdit(id, t);
    };
    handleDeleteOpen = (id) => {
        const {openExamDelete, t} = this.props;
        openExamDelete(id, t);
    };
    render() {
        const {classes, gridRows, exams, i18n, t} = this.props;
        const currentLang = i18n.language;
        const {handleEditOpen, handleDeleteOpen} = this;
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    {gridRows.length
                        ? <TableContainer>
                            <Table className={classes.tableBorder} size="small" aria-label="a exam table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">
                                            <Typography variant="body1">№</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body1">{t('name')}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body1">{t('type')}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body1">{t('applicant_ball')}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body1">{t('admissions_committee_ball')}</Typography>
                                        </TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {gridRows.map((gridRow, numGridRow) => {
                                        const examIndex = findExamIndex(exams, gridRow.exam_id);
                                        const examTypeIndex = findExamTypeIndex(configExamTypes, gridRow.type);
                                        return (
                                            <TableRow key={gridRow.id}>
                                                <TableCell align="center">
                                                    <Typography variant="body1">
                                                        {numGridRow + 1}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {examIndex !== -1 ?
                                                            currentLang === 'en' ? exams[examIndex].name_en : exams[examIndex].name
                                                            : <i>{t('unknown')}</i>}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {examTypeIndex !== -1
                                                            ? t(configExamTypesTranslatedConf[examTypeIndex].name)
                                                            : <i>{t('unknown')}</i>}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {gridRow.ball}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {gridRow.admissions_committee_ball}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <IconButton
                                                        aria-label="edit"
                                                        color="primary"
                                                        size="small"
                                                        title={t('edit')}
                                                        onClick={() => {handleEditOpen(gridRow.id)}}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                    <IconButton
                                                        aria-label="delete"
                                                        color="secondary"
                                                        size="small"
                                                        title={t('delete')}
                                                        onClick={() => {handleDeleteOpen(gridRow.id)}}
                                                    >
                                                        <Close />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        : null}
                </Grid>
                <Grid item xs={12}>
                    <Button variant="outlined" size="small" onClick={() => {handleEditOpen()}}>
                        {t('add_entrance_test')}
                    </Button>
                </Grid>
                <GridEdit />
                <GridDelete />
            </Grid>
        )
    };
}

function mapStateToProps(state) {
    return {
        gridRows: cloneDeep(state.applicantExams),
        exams: cloneDeep(state.exams),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openExamEdit,
        openExamDelete,
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(GridContainer));